import React from 'react';

function InternalLinks({
    data,
}) {
    return (
        <div className="internalLinks">
            <div className="internal-links-content-left">
                <img loading="lazy" className="internal-links-content-left__img" src={data.image.sourceURL} alt={data.image.altText} />
            </div>
            <div className="internal-links-content-right">
                <div className="internal-links-content-right__title" dangerouslySetInnerHTML={{ __html: data.title }} />
                <div className="internal-links-content-right__text" dangerouslySetInnerHTML={{ __html: data.text }} />
            </div>
        </div>
    );
}

export default InternalLinks;
